import { ActionTree } from 'vuex';
import { IKrogerCheckoutState } from './state';
import { SET_GO_TO_CART_OPEN } from './types';

const actions: ActionTree<IKrogerCheckoutState, IKrogerCheckoutState> = {
    [SET_GO_TO_CART_OPEN]: async ({ commit }, payload: boolean): Promise<void> => {
        try {
            commit(SET_GO_TO_CART_OPEN, payload);
            return;
        } catch (err) {
            throw err;
        }
    },
};

export default actions;
